// HTMLの生成はRails側で行うため、全体はComponentを作らない
import {
  onMounted,
  ref
} from 'vue'

import { useIntlTel } from '@composables/useIntlTel.js'
import { useRecaptcha } from '@composables/useRecaptcha.js'
import { preventDuplicatedRequests, preventEnterSubmit } from '@shared/util.js'

export default {
  setup() {
    const {
      intlCountry,
      intlNumber,
      initializeIntlTel
    } = useIntlTel("#intl_phone")

    const { recaptchaToken, initializeRecaptcha } = useRecaptcha()

    const { country, phone } = window.app.page

    onMounted(() => {
      initializeIntlTel({ country, phone })
      initializeRecaptcha('inquiry')
      preventDuplicatedRequests()
      preventEnterSubmit()
    })

    return {
      intlCountry,
      intlNumber,
      recaptchaToken,
    }
  },
}
